import ChevronRight from "@mui/icons-material/ChevronRight";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CustomLink } from "core/components/CustomLink";
import { useBreakpoints } from "core/hooks/useBreakpoints";
import { useDmsDocumentHref } from "features/DMS/hooks";
import { NotificationDot } from "features/Notifications/NotificationDot";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FileAvatar } from "../DmsDocDocumentNodesDisplay/FileAvatar";
import { DMSWidgetListItemTemplate } from "./DMSWidgetListItemTemplate";
import type { SharedDMSWidgetListItemProps } from "./defs";
import { formatDmsDocumentLink } from "./formatDmsDocumentLink";

export type DMSWidgetFileListItemProps = SharedDMSWidgetListItemProps & {
  fileId: string;
  fileName: string;
};
export function DMSWidgetFileListItem({
  id,
  title,
  fileId,
  fileName,
  dateLabel,
  dateText,
  parents,
  onDocClick,
  path,
  ...rest
}: DMSWidgetFileListItemProps) {
  const { t } = useTranslation("DocumentManagementSystem", {
    keyPrefix: "Next:DocumentManagementSystem:DMSWidgetDocumentListItem",
  });
  const visitHref = useDmsDocumentHref(fileId, fileName, null, "inline");
  const downloadHref = useDmsDocumentHref(fileId, fileName, null, "attachment");
  const onClick = useCallback(() => onDocClick?.(id!), [onDocClick, id]);

  const isPDF = fileName.endsWith(".pdf");
  const { isMobile } = useBreakpoints();
  return (
    <DMSWidgetListItemTemplate
      id={id}
      title={title}
      {...rest}
      dateText={dateText}
      dateLabel={dateLabel}
      parents={parents}
      AvatarSlot={
        <CustomLink href={formatDmsDocumentLink(path)}>
          <FileAvatar fileName={fileName} />
        </CustomLink>
      }
      TitleSlot={
        <CustomLink href={formatDmsDocumentLink(path)}>
          <Typography variant="body1" sx={{ pb: 1 }} fontWeight="bold">
            {title} <NotificationDot id={id} mode="self" />
          </Typography>
        </CustomLink>
      }
      ButtonSlot={
        <Stack direction="column">
          <Button
            size="small"
            sx={{ flexGrow: 1 }}
            endIcon={<DownloadIcon />}
            onClick={onClick}
            download
            href={downloadHref}
            target="_blank"
          >
            {!isMobile && t("downloadButton")}
          </Button>
          {isPDF && (
            <Button
              sx={{ flexGrow: 1 }}
              size="small"
              onClick={onClick}
              target="_blank"
              href={visitHref}
              endIcon={<ChevronRight />}
            >
              {!isMobile && t("visitButton")}
            </Button>
          )}
        </Stack>
      }
    />
  );
}
